<div class="table-responsive" *ngIf="kullanicilar">
  <table class="table card-table table-vcenter text-nowrap datatable">
    <thead>
    <tr>
      <th class="w-1">Id</th>
      <th>Kullanıcı Adı</th>
      <th>Ad Soyad</th>
      <th>Eposta Adresi</th>
      <th *ngIf="showGrupInfoVal">Kullanıcı Grubu</th>
      <th *ngIf="showSubeInfoVal">Şubeler</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let k of kullanicilar">
      <td><span class="text-muted">{{k.id}}</span></td>
      <td>{{k.kullaniciAdi}}</td>
      <td>{{k.adSoyad}}</td>
      <td>{{k.epostaAdresi}}</td>
      <td *ngIf="showGrupInfoVal"><span class="text-blue clickable" (click)="showKullaniciGrupDetails(k.kullaniciGrupId)">{{k.kullaniciGrup?.isim}}</span></td>
      <td *ngIf="showSubeInfoVal"><span *ngFor="let k of k.kullaniciSubeler" class="text-blue clickable" (click)="showSubeGrupDetails(k.sube?.id)">{{k.sube?.isim}} </span></td>
      <td class="text-right">
        <div class="btn btn-sm btn-success" (click)="incele(k)">İncele</div>
        <div class="btn btn-sm btn-danger ml-3" (click)="kaldir(k)">Kaldır</div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
